import React from 'react';
import { Grid, TextField, Button, Icon, GridSize } from '@material-ui/core';

type TextInputProps = {
    value: string;
    setValue: (value: string) => void;
    titulo: string;
    size?: boolean | GridSize | undefined;
};

const TextInput: React.FC<TextInputProps> = ({ value, setValue, titulo, size = 2 }) => {
    return (
        <Grid
            item
            xs={size}
        >
            <Grid
                // container
                style={{
                    marginTop: '0.5rem',
                    marginBottom: '0.5rem',
                    border: '1px solid #ccc',
                    padding: '8px',
                    borderRadius: '4px',
                }}
            >
                <Grid item>
                    <TextField
                        fullWidth
                        label={titulo}
                        variant="standard"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        InputLabelProps={{ style: { color: '#000' }, shrink: true }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default TextInput;
